module.exports = __webpack_public_path__ + "static/media/icon_nosotros_rapido.79dd1cb9.svg";